import { getSchoolContext } from '@/hooks/useAuthentication';
import { useQuery } from '@apollo/client';
import { FETCH_PROGRAMMES, FetchProgrammesQuery, FetchProgrammesQueryVariables } from '@edwin-group/cj-graphql';

export const useProgrammesList = () => {
  const {
    data: programmesResult,
    error: programmesError,
    loading,
  } = useQuery<FetchProgrammesQuery, FetchProgrammesQueryVariables>(FETCH_PROGRAMMES, {
    fetchPolicy: 'cache-and-network',
    variables: {
      schoolId: getSchoolContext()?.documentId,
    },
  });

  return {
    programmes: programmesResult?.programmes,
    page: programmesResult?.programmePage,
    loading,
    errors: [programmesError].filter(Boolean),
  };
};
